import React, { useState } from "react";
import "./Manuals.scss";
import manualesIcon from "../../assets/icons/manuales/icono_manuales.svg";
import faqIcon from "../../assets/icons/manuales/icono_faq.svg";
import videosIcon from "../../assets/icons/manuales/icono_videos.svg";
// import comoPagarIcon from "../../assets/icons/manuales/icono_como_pagar.svg";
// import atencionIcon from "../../assets/icons/manuales/icono_atenciom_person.svg";
import ManualCategoryCircle from "../../components/atoms/ManualCategoryCircle/ManualCategoryCircle";
// import Select from "../../components/atoms/Select/Select";
// import Button from "../../components/atoms/Button/Button";
import CardView from "../../components/molecules/CardView/CardView";
// import Input from "../../components/atoms/Input/Input";
// import buscarIcon from "../../assets/icons/BUSCAR.png";
import SeccionManuales from "./SeccionManuales";
import Videos from "../Videos/Videos";
import Faq from "../Faq/Faq";
import ComoPagarMembresia from "../ComoPagarMembresia/ComoPagarMembresia";
import AtencionPersonalizada from "../AtencionPersonalizada/AtencionPersonalizada";

const Manuals = () => {
    const pdfs = [
        {
            id: 1,
            titulo: "Pago1",
            categoria: "PAGO DE MEMBRESIA",
            descripcion:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit",
            link: "#",
        },
        {
            id: 2,
            titulo: "Pago2",
            categoria: "PAGO DE MEMBRESIA",
            descripcion:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit",
            link: "#",
        },
        {
            id: 3,
            titulo: "Pago3",
            categoria: "PAGO DE MEMBRESIA",
            descripcion:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit",
            link: "#",
        },
        {
            id: 4,
            titulo: "Pago4",
            categoria: "PAGO DE MEMBRESIA",
            descripcion:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit",
            link: "#",
        },
        {
            id: 1,
            titulo: "Pago1",
            categoria: "PAGO DE MEMBRESIA",
            descripcion:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit",
            link: "#",
        },
    ];
    const [seccion, setSeccion] = useState("manual");

    return (
        <CardView>
            <div className="Manuals">
                <div className="containerCategories">
                    <ManualCategoryCircle
                        img={manualesIcon}
                        title="MANUALES"
                        onClick={() => {
                            setSeccion("manual");
                        }}
                    ></ManualCategoryCircle>
                    <ManualCategoryCircle
                        img={faqIcon}
                        title="FAQ"
                        onClick={() => {
                            setSeccion("faq");
                        }}
                    ></ManualCategoryCircle>
                    <ManualCategoryCircle
                        img={videosIcon}
                        title="VIDEOS"
                        onClick={() => {
                            setSeccion("videos");
                        }}
                    ></ManualCategoryCircle>
                    {/* <ManualCategoryCircle
                        img={comoPagarIcon}
                        title="COMO PAGAR MEMBRESIAS"
                        onClick={() => {
                            setSeccion("membresias");
                        }}
                    ></ManualCategoryCircle> */}
                    {/* <ManualCategoryCircle
                        img={atencionIcon}
                        title="ATENCIÓN PERSONALIZADA"
                        onClick={() => {
                            setSeccion("atencion");
                        }}
                    ></ManualCategoryCircle> */}
                </div>

                {seccion === "manual" && (
                    <div className="manualesContainer">
                        <div className="titulo">Manuales</div>
                        <SeccionManuales></SeccionManuales>
                    </div>
                )}
                {seccion === "faq" && <Faq></Faq>}
                {seccion === "videos" && <Videos />}
                {seccion === "membresias" && (
                    <>
                        <div className="titulo">COMO PAGAR MEMBRESIAS</div>
                        <ComoPagarMembresia pdfs={pdfs} />
                    </>
                )}
                {seccion === "atencion" && (
                    <>
                        <AtencionPersonalizada />
                    </>
                )}
            </div>
        </CardView>
    );
};
export default Manuals;
